export default __webpack_public_path__ + "images/3f7a4f24566f4a14879ad21bc6c167aa.jpg";